import React, { useEffect } from "react";
import SEO from "@src/components/SEO";
import HeroComponent from "@src/components/partials/landing-pages/HeroComponent";
import SectionTitle from "@src/components/partials/landing-pages/SectionTitleComponent";
import FeatureComponent from "@src/components/partials/landing-pages/FeatureComponent";
import FeatureGridComponent from "@src/components/partials/landing-pages/FeatureGridComponent";
import { FeatureGridContainer } from "@src/components/partials/landing-pages/FeatureGridComponent/styles";
import { lpComponentTypes } from "@src/components/partials/landing-pages/constants";

interface LandingPageProps {
  pageContext: {
    components: any;
    seoTitle: string;
    seoDescription: string;
  };
}

const LandingPage: React.FC<LandingPageProps> = ({ pageContext }) => {
  const { components, seoTitle, seoDescription } = pageContext;

  return (
    <>
      <SEO title={seoTitle} description={seoDescription} />
      {components.map((component, index) => {
        if (component.component_type === lpComponentTypes.HERO) {
          return <HeroComponent {...component} key={index} />;
        }
        if (component.component_type === lpComponentTypes.SECTION_TITLE) {
          return <SectionTitle {...component} key={index} />;
        }
        if (component.component_type === lpComponentTypes.FEATURE) {
          return <FeatureComponent {...component} key={index} />;
        }
        if (component.component_type === lpComponentTypes.FEATURE_GRID) {
          return (
            <FeatureGridContainer key={index}>
              {component.items.map((item, index) => {
                return <FeatureGridComponent {...item} key={index} />;
              })}
            </FeatureGridContainer>
          );
        }
      })}
    </>
  );
};

export default LandingPage;
